import AlephBet from "alephbet"
import {
  storageAdapter,
  superPropertiesLamedAdapter
} from "./adapters"
import {
  getUserId,
  onStudyUnit,
  onDashboard,
  loggedInUser,
  loggedInPotentialCustomer
} from "./helpers"
import {
  quizOrVideoStarted,
  pricingPageVisited,
  checkoutPageVisited,
  premiumSubscriptionStarted
} from "./goals"

export default () => {
  const productTours = new AlephBet.Experiment({
    name: "202505 Product tours (2)",
    /* eslint-disable camelcase */
    tracking_adapter: superPropertiesLamedAdapter,
    storage_adapter: storageAdapter,
    user_d: getUserId(),
    /* eslint-enable camelcase */
    trigger: () =>
      (onStudyUnit() || onDashboard()) &&
      loggedInPotentialCustomer() &&
      // Tue, 13 May 2025 12:00:00 +0000
      loggedInUser().confirmedAt > 1747137600,
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Tours": {
        activate: experiment => {
          if (!experiment.options.trigger()) return

          window.gon.showProductTours = true
        }
      }
    }
  })
  productTours.add_goals([
    quizOrVideoStarted,
    pricingPageVisited,
    checkoutPageVisited,
    premiumSubscriptionStarted
  ])
}
